import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {styled} from "@mui/material/styles";
import {BadgeContext} from "../BadgeContext";

Label.propTypes = {
    label: PropTypes.string,
};

const StyledLabel = styled('span', {
    shouldForwardProp: (prop) => !['isBold', 'color'].includes(prop)
})(({ theme, color, isBold }) => ({
    lineHeight: 'normal',
    color: theme.palette[color]?.main ?? color,
    fontSize: '12px',
    fontWeight: isBold ? 600 : 400,
    whiteSpace: 'nowrap'
}));

function Label({label, ...props}) {
    const {color, labelColor, isBold} = useContext(BadgeContext);

    return (
        <StyledLabel color={labelColor ?? color} isBold={isBold}>
            {label || props.children}
        </StyledLabel>
    );
}

export default Label;
